import sensorLog from "@/utils/sensorLog"
import * as types from "@/constants"
export const notSupport = args => {
  let { isValidOS, isValidBrowser } = args

  if (!isValidOS) {
    // 系统不兼容提示
    document.body.style.backgroundColor = "#e1e1e1"
    document.getElementById("teacherOSNotSupport").style.display = "block"

    sensorLog.track(
      "enterRoom_userAgent_deteck_invalid_os",
      types.SENSORLOG.type.FAILED,
      JSON.stringify(window.navigator.userAgent)
    )
    return false
  } else if (!isValidBrowser) {
    // 浏览器不兼容
    document.body.style.backgroundColor = "#e1e1e1"
    document.getElementById("teacherBrowserNotSupport").style.display = "block"
    document
      .getElementById("teacherDownload")
      .addEventListener("click", function() {
        sensorLog.track(
          "enterRoom_userAgent_deteck_teacher_click_download_chrome",
          types.SENSORLOG.type.SUCCESSED,
          this.href
        )
      })
    sensorLog.track(
      "enterRoom_userAgent_deteck_invalid_browser",
      types.SENSORLOG.type.FAILED,
      JSON.stringify(window.navigator.userAgent)
    )
  } else {
    return true
  }
}
